var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m211 512v-46c-33.091 0-60-26.909-60-60s26.909-60 60-60v-45h-83.848l7.134-20.039c1.143-3.179 1.714-6.533 1.714-9.961 0-16.538-13.462-30-30-30s-30 13.462-30 30c0 3.428.571 6.782 1.714 9.961l7.134 20.039h-84.848c7.443 112.092 98.908 203.557 211 211z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106 211c33.091 0 60 26.909 60 60h45v-83.848l20.039 7.134c18.472 6.577 39.946-8.335 39.961-28.286-.015-19.966-21.475-34.995-39.961-28.286l-20.039 7.134v-83.088c-112.092 7.443-203.557 97.148-211 209.24h46c0-33.091 26.909-60 60-60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450.24 301h-44.24c0 33.091-26.909 60-60 60s-60-26.909-60-60h-45v83.848l-20.039-7.134c-18.545-6.665-39.976 8.32-39.961 28.286-.015 19.966 21.431 34.951 39.961 28.286l20.039-7.134v84.848c112.092-7.443 201.797-98.908 209.24-211z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451 121v-60h-60c0-33.091-26.909-61-60-61s-60 27.909-60 61h-30v45c33.091 0 60 26.909 60 60s-26.909 60-60 60v45h83.848l-7.134 20.039c-1.143 3.179-1.714 6.533-1.714 9.961 0 16.538 13.462 30 30 30s30-13.462 30-30c0-3.428-.571-6.782-1.714-9.961l-7.134-20.039h83.848v-30c33.091 0 61-26.909 61-60s-27.909-60-61-60z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills);
export default __webpack_public_path__ + "static/media/skills.8db5372d5e4d8c4d7c442b1ffd300900.svg";
export { ForwardRef as ReactComponent };